import Cards from './components/Cards'
import Filters from './components/Filters'
import FirstCharts from './components/FirstCharts'
import SecondCharts from './components/SecondCharts'
import ThirdCharts from './components/ThirdCharts'

export default function DashboardPage () {
  return (
    <div className='space-y-6'>
      <Filters />
      <Cards />
      <FirstCharts />
      <SecondCharts />
      <ThirdCharts />
    </div>
  )
}
